// Factory + helpers for canvas elements (text + photo placeholders).

let nextLocalId = 0;
const localId = () => {
  nextLocalId += 1;
  return `el-${Date.now()}-${nextLocalId}`;
};

export function makeTextElement(partial = {}) {
  return {
    type: 'text',
    id: localId(),
    x: 60,
    y: 60,
    width: 300,
    height: 100,
    text_content: 'New text',
    font_size: 40,
    color: '#ffffff',
    font_family: 'GOTHICB',
    fit_mode: 'shrink_to_fit', // 'fixed' | 'shrink_to_fit' | 'best_fit' | 'word_wrap'
    ...partial,
  };
}

export function makePhotoElement(partial = {}) {
  return {
    type: 'photo',
    id: localId(),
    x: 80,
    y: 80,
    width: 200,
    height: 250,
    pose_number: 1,
    orientation: '4x5',
    label: 'Student Photo',
    shape: 'rectangle',
    drop_shadow: {
      enabled: false, color: '#000000', opacity: 50, blur: 10, x_offset: 6, y_offset: 6,
    },
    ...partial,
  };
}

export function describeElement(el) {
  if (el.type === 'text') {
    const label = (el.text_content || '').slice(0, 18) || 'Text';
    return { title: label, meta: el.fit_mode?.replace('_', ' ') };
  }
  return { title: el.label || 'Student Photo', meta: `Pose ${el.pose_number}` };
}
